module.exports = __webpack_public_path__ + "static/img/BottomBackground.02f0830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightsDetails/Daoan/BottomBackground.png
// module id = CKo7
// module chunks = 59